export default "__VITE_ASSET__DT$71ozo__"